import React from "react";
import { motion } from "framer-motion";

const Bootstrap = ({ icon }) => {
  return (
    <div className="svgElement">
      <motion.svg
        height="1992"
        viewBox="0 0 512 407.864"
        width="2500"
        xmlns="http://www.w3.org/2000/svg"
      >
        <motion.path
          d="M106.344 0C77.13 0 55.513 25.57 56.481 53.3c.929 26.641-.278 61.145-8.964 89.283C38.8 170.8 24.068 188.681 0 190.976v25.912c24.068 2.3 38.8 20.172 47.516 48.393 8.687 28.138 9.893 62.642 8.964 89.283-.968 27.726 20.649 53.3 49.868 53.3h299.347c29.214 0 50.827-25.57 49.859-53.3-.929-26.641.278-61.145 8.964-89.283 8.717-28.221 23.413-46.1 47.482-48.393v-25.912c-24.068-2.3-38.764-20.172-47.482-48.393-8.687-28.134-9.893-62.642-8.964-89.283.968-27.726-20.645-53.3-49.859-53.3H106.34zm240.775 251.067c0 38.183-28.481 61.34-75.746 61.34h-80.458a8.678 8.678 0 01-8.678-8.678V104.136a8.678 8.678 0 018.678-8.678h80c39.411 0 65.276 21.348 65.276 54.124 0 23.005-17.4 43.6-39.567 47.208v1.2c30.176 3.31 50.495 24.21 50.495 53.077zm-84.519-128.1h-45.876v64.8h38.639c29.87 0 46.34-12.028 46.34-33.527-.003-20.148-14.163-31.273-39.103-31.273zm-45.876 90.511v71.411h47.564c31.1 0 47.573-12.479 47.573-35.931s-16.935-35.484-49.573-35.484h-45.564z"
          fill="#f5f5f5"
          fill-rule="evenodd"
          variants={icon}
          initial="hidden"
          animate="visible"
          transition={{
            default: { duration: 4, ease: "easeInOut" },
            fill: { duration: 4, ease: [1, 0, 0.8, 1] },
          }}
        />
      </motion.svg>
    </div>
  );
};

export default Bootstrap;
